<template>
  <div id="app">
    <Cookies v-if="$route.name === 'home' || $route.name === 'login'"/>
    <modals-container/>
    <Header :height="headerHeight" v-if="$route.name === 'home' || $route.name === 'details'"/>
    <Nav :height="navHeight" v-if="$route.name === 'home' || $route.name === 'details'"/>
    <el-main class="main">
      <!-- <transition name="fade"> -->
      <router-view/>
      <!-- </transition> -->
      <Footer />
    </el-main>
  </div>
</template>

<script>
  import Cookies from '@/components/Cookies'
  import Header from '@/components/Header'
  import Nav from '@/components/Nav'
  import Footer from '@/components/Footer'
  export default {
    name: 'App',
    data () {
      return {
        showModal: false,
        headerHeight: '0px',
        navHeight: '0px',
        email: ''
      }
    },
    mounted () {
      this.resize()
      if (this.$route.query.t && this.$route.query.t === 'welcome') {
        this.$router.push({name: 'new'})
      }
      window.addEventListener('resize', () => {
        this.resize()
      })
    },
    methods: {
      resize () {
        if (window.innerWidth > 700) {
          this.headerHeight = '97px'
          this.navHeight = '66px'
        } else {
          this.headerHeight = '66px'
          this.navHeight = '46px'
        }
      }
    },
    components: {
      Cookies,
      Header,
      Nav,
      Footer
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: 'Roboto', sans-serif;
}

.main {
  background-color: #F5F7FA;
  min-height: calc(100vh - 163px);
  height: 100%;
  padding: 0;
  @media (max-width: 700px) {
    min-height: calc(100vh - 112px);
  }
  padding-bottom: 14%;
}


</style>
